import { ComponentProps, forwardRef } from "react";

import { cn } from "./cn";

// 네이티브 radio 한 개 — 묶음·선택값은 부르는 쪽이 name·checked 로 정하고, 여기서는 크기·색(accent-primary)·포커스 링만 맞춘다.
const Radio = forwardRef<HTMLInputElement, Omit<ComponentProps<"input">, "type">>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "size-4 shrink-0 cursor-pointer rounded-full accent-primary ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
      type="radio"
    />
  )
);
Radio.displayName = "Radio";

export { Radio };
